import config from '@/config';
export default {
  "drawer": null,
  "software": config.software,
  "items": [
        { icon: 'lightbulb_outline', text: 'Notes' },
        { icon: 'touch_app', text: 'Reminders' },
        { divider: true },
        { heading: 'Labels' },
        { icon: 'add', text: 'Create new label' },
        { divider: true },
        { icon: 'archive', text: 'Archive' },
        { icon: 'delete', text: 'Trash' },
        { divider: true },
        { icon: 'settings', text: 'Settings' },
        { icon: 'chat_bubble', text: 'Trash' },
        { icon: 'help', text: 'Help' },
        { icon: 'phonelink', text: 'App downloads' },
        { icon: 'keyboard', text: 'Keyboard shortcuts' }
      ],
  "theme": {
    "layout": {
      "menuBreakpoint" : 960
    },
    "toolbar": {
      flat: true,
      color: '#7F99AC',
      dark: true,
      height: 143,
      extension: {
        color: '#F9F9F9',
        dark: false,
        height: 50
      }
    },
    "colors": {
        'body': "red",
        'toolbar' : 'white',
        'menu' : 'transparent'
    }
  },
  
  "view": {
    "layout": 'd3',
    "gutter" : 10,
    "percentage": 100,
    "limit": 500,
    "type": 'leads',
    "offsetTop": 0,
    "pageSize": 30,
    "threshold": 50,
    "card": {
      width: 500
    }
  },
  "message" :"",
  "image": 'https://demos.creative-tim.com/vue-material-dashboard/img/sidebar-2.32103624.jpg',
  "footer" : false,
  "menu" : true,
  "mini": false,
  "chat" : false,
  "template" : true,
  "edit": false,
  "preview" : false,
  "deeplink" : false
}
